module.exports = __webpack_public_path__ + "img/odaee.98fe2357.png";